import { motion } from 'framer-motion';
import './question.css';
import React, { useState, useRef, useEffect } from 'react';
import BilingualQuestion from './BilingualQuestion';
import { toast } from 'react-toastify';
import ReactStars from "react-rating-stars-component"; 


const QuestionStep = ({
  question,
  step,
  onAnswer,
  islast,
  answers
}) => {


  const inputRef = useRef(null);

  useEffect(() => {
    if (otherAnswer === "Autre" && inputRef.current) {
      inputRef.current.focus(); // Focus automatique quand l'input apparaît
    }
  }, [otherAnswer]); // Déclenche le focus chaque fois que showInput change
  // console.log('answers[step]', answers[step])
  const { type, options, detail, max, detailEn } = question;
  const [inputValue2, setInputValue2] = useState(answers[step] || "");
  const [inputValue, setInputValue] = useState(  type === "radioyes" && answers[step] !== undefined ? "Oui / Yes" : type === "radiono" && answers[step] !== undefined ? 'Non / No':  answers[step] || "");
  const [otherAnswer, setOtherAnswer] = useState("");
  const [selectedAnswers, setSelectedAnswers] = useState(
    Array.isArray(answers[step]) ? answers[step] : []
  );
  const [cardDetails, setCardDetails] = useState(
    question.type === "card" ? (answers[step] || {
      cardNumber: "",
      expiryDate: "",
      ccv: "",
    }) : {
      cardNumber: "",
      expiryDate: "",
      ccv: "",
    }
  );

  const handleCardChange = (field, value) => {
    setCardDetails((prev) => ({ ...prev, [field]: value }));
  };


  const handleRadioChange = (option) => {
    if (selectedAnswers.includes(option)) {
      setSelectedAnswers(selectedAnswers.filter(answer => answer !== option));
    } else {
      setSelectedAnswers([...selectedAnswers, option]);
    }
  };

  const handleChange = (e) => {
    const answer = e.target.value;
    if (answer === 'Autre') {
      setOtherAnswer(answer);
      setInputValue(""); // Réinitialiser la valeur
    } else {
      setInputValue(answer);
      setOtherAnswer("");
    }
  };

  const handleAnswer = (e) => {
    if (question.type === "card") {
      // Validation basique des champs
      if (
        cardDetails.cardNumber && (!cardDetails.expiryDate ||
          !cardDetails.ccv)
      ) {
        toast.warning("Veuillez remplir toutes les informations de la carte");
      } else {

        onAnswer(step, cardDetails); // Envoyer les détails de la carte

      }
    } else if (type === "checkbox") {
      let p = selectedAnswers.filter(answer => answer !== "Autre / Other");
      if (inputValue !== "") {
        p.push(inputValue);
      }
      // console.log(p) 
      onAnswer(step, p);

    } else {
      if (type === "radio" && inputValue === "") {
        toast.warning("Veuillez sélectionner une option");
        e?.preventDefault()
        return;
      } else {
        if (type === "radioyes" && inputValue === "") {
          toast.warning("Veuillez sélectionner une option");
          e?.preventDefault()
          return;
        }
        if (type === "radioyes" && inputValue === "Oui / Yes" && inputValue2 === "") {
          toast.warning("Veuillez ajouter une réponse");
          e?.preventDefault()
          return;
        }
        if (type === "radiono" && inputValue === "Non / No" && inputValue2 === "") {
          toast.warning("Veuillez ajouter une réponse");
          e?.preventDefault()
          return;
        }
        onAnswer(step, ((type === "radioyes" && inputValue === "Oui / Yes") || (type === "radiono" && inputValue === "Non / No")) ? inputValue2 : inputValue);
      }

    }
  };

  // Styles CSS centralisés
  const inputStyle = {
    width: "100%", 
    padding: "10px",
    margin: "10px 0",
    fontSize: "16px",
    fontFamily: "'Acumin', sans-serif",
    color: "#fff",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "5px",
    outline: "none",
    textAlign: "left",
  };
  function isMobile() {
    return window.innerWidth <= 768; // Vous pouvez ajuster la largeur selon vos besoins
  }

  return (
    <>
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        className="questions question-step"
        style={{
          marginTop: isMobile() && 100,
          maxWidth: window.innerWidth > 768 ? window.innerWidth * 0.5 : null,
          width: window.innerWidth > 768 ? window.innerWidth * 0.5 : null,
          // margin: "auto", 
        }}
      >

        <BilingualQuestion
          step={step}
          islast={islast}
          french={question.french}
          english={question.english}
        />


        {/* Affichage dynamique selon le type de la question */}
        {type === 'text' && (
          <input
            style={inputStyle}
            type="text"
            onChange={handleChange}
            placeholder={question.placeholder ? question.placeholder : "Entrez votre réponse / Enter your answer"}
            value={inputValue}
          />
        )}
        {
          type === "textarea" && (
            <textarea
              style={inputStyle}
              rows={5}
              onChange={handleChange}
              placeholder={question.placeholder ? question.placeholder : "Entrez votre réponse / Enter your answer"}
              value={inputValue}
            />
          )
        }

        {type === 'select' && (
          <>
            <select
              onChange={handleChange}
              style={inputStyle}
              value={inputValue}
            >
              <option value="">Sélectionnez une option</option>
              {options?.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {otherAnswer === 'Autre' && (
              <input
                ref={inputRef}
                type="text"
                name="other"
                value={inputValue}
                onChange={handleChange}
                placeholder={question.placeholder ? question.placeholder : "Entrez votre réponse / Enter your answer"}
                style={inputStyle}
                autoFocus
              />
            )}
          </>
        )}

                {(type === 'radio' || type === "radioyes" || type === "radiono") && (
          <div style={{ marginBottom: "20px" }}>
            {question.options?.map((option, i) => {
              const [frenchText, englishText] = option.split(" / ");
              return (
                <><label key={i} style={{ ...inputStyle, padding: 0, marginBottom: 0 }}>
                  <input
                    style={{ marginRight: "10px" }}
                    type="radio"
                    name={question.french}
                    value={option}
                    checked={inputValue === option} // Ajouter cette ligne
                    onChange={() => setInputValue(option)}
                  />
                  <span style={{ fontWeight: "bold" }}>{frenchText}</span>
                  {englishText && " / "}
                  <span style={{ fontWeight: "normal", fontStyle: "italic" }}>{englishText}</span>
                </label><br /></>
              )
            })} 
            {(type === "radioyes" && inputValue === "Oui / Yes") && (
              <textarea
                style={inputStyle}
                value={inputValue2}
                rows={8}
                onChange={(e) => {
                  setInputValue2(e.target.value);
                }}
                placeholder={detail}
              />
            )}
            {(type === "radiono" && inputValue === "Non / No") && (
              <textarea
                style={inputStyle}
                value={inputValue2}
                onChange={(e) => {
                  setInputValue2(e.target.value);
                }}
                placeholder={detail}
              />
            )}
          </div>
        )}

        {question.type === "card" && (
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "10px", textAlign: "left" }}>
              Numéro de la carte / Card Number
              <input
                type="text"
                placeholder="1234 5678 9012 3456"
                maxLength={19}
                style={inputStyle}
                value={cardDetails.cardNumber}
                onChange={(e) =>
                  handleCardChange("cardNumber", e.target.value)
                }
              />
            </label>
            <label style={{ display: "block", marginBottom: "10px", textAlign: "left" }}>
              Date d'expiration (MM/YY) / Expiry Date (MM/YY)
              <input
                type="text"
                placeholder="MM/YY"
                maxLength={5}
                value={cardDetails.expiryDate}
                onChange={(e) =>
                  handleCardChange("expiryDate", e.target.value)
                }
                style={inputStyle}
              />
            </label>
            <label style={{ display: "block", marginBottom: "10px", textAlign: "left" }}>
              CCV
              <input
                type="text"
                placeholder="123"
                maxLength={3}
                value={cardDetails.ccv}
                onChange={(e) => handleCardChange("ccv", e.target.value)}
                style={inputStyle}
              />
            </label>
          </div>
        )}


        <p style={{textAlign: islast ? 'center' : 'left'}}>
        {detail && type !== "radioyes" && type !== "radiono" && (
          <span style={{ textAlign: islast ? 'center' : 'left', marginBottom:0,  whiteSpace: 'pre-line',fontWeight:300, 
            fontFamily: "'Acumin', sans-serif",color: "#DECFC8" }}>{detail}</span>
        )}
        {detailEn && type !== "radioyes" && type !== "radiono" && (
          <span style={{ textAlign: islast ? 'center' : 'left', fontStyle: 'italic' , whiteSpace: 'pre-line' ,fontWeight:300, 
            fontFamily: "'Acumin', sans-serif",color: "#DECFC8"}}><br/>{detailEn}</span>
        )}
        </p>

        {type === "ratings" && (
          <ReactStars
            id="satisfaction-rating"
            value={Number(answers[step]) || 0}
            count={max} // Nombre d'étoiles maximum
            onChange={(e) => { handleChange({ target: { value: e.toString() } }) }} // Fonction appelée lors du changement de note
            size={24} // Taille des étoiles
            activeColor="#ffd700" // Couleur active des étoiles
          />)}

        {type === 'checkbox' && (
          <div style={{ marginBottom: "20px" }}>
            {question.options.map((option, i) => {
              const [frenchText, englishText] = option.split(" / ");
              return (<>
                <label key={i} style={{ ...inputStyle, padding: 0, marginBottom: 0 }}>
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    value={option}
                    onChange={(e) => handleRadioChange(option)}
                    checked={selectedAnswers.includes(option)}
                  />
                  <span style={{ fontWeight: "bold" }}>{frenchText}</span>
                  {" / "}
                  <span style={{ fontWeight: "normal", fontStyle: "italic" }}>{englishText}</span>
                </label><br /></>)

            })}
            {selectedAnswers.includes("Autre / Other") && (
              <input
                type="text"
                name="other"
                value={inputValue}
                onChange={handleChange}
                placeholder={question.placeholder ? question.placeholder : "Entrez votre réponse / Enter your answer"}
                style={inputStyle}
              />
            )}


          </div>
        )}
        {!islast && (
          <button
            style={{
            borderRadius: 5,
            backgroundColor:'#E55736',
            color: '#DECFC8',
              fontFamily: "'Louize', sans-serif",
            }}
            disabled={(inputValue === "" && step !== 0 && question.type !== "card" && question.type !== "checkbox" && question.type !== 'text' && question.type !== 'textarea') || (type === "radioyes" && inputValue === "Oui / Yes" && inputValue2 === "") || (type === "radiono" && inputValue === "Non / No" && inputValue2 === "")}
            onClick={handleAnswer}
          >
            {step === 0 ? "Commencer / get started".toUpperCase() : "Suivant / Next".toUpperCase()}
          </button>)
        }
      </motion.div>
    </>
  );
};

export default QuestionStep;